const LIST_TRANSITION_DURATION = 200;
const ENTER_TRANSITION_DURATION_MS = 200;
const pageCls = "_275p726s4x";
const header = "_275h1fgehiw";
const transitionCls = "_275trwpbm7";
const content = "_275c1ed3p49";
const listCls = "_275lxdtv9y";
const select = "_275s17jqwm1";

export { ENTER_TRANSITION_DURATION_MS, LIST_TRANSITION_DURATION, content, header, listCls, pageCls, select, transitionCls };
import "./page.style.linaria.module.css";
//# sourceMappingURL=page.style.js.map
